import { registerRoute } from "../server";
import { DiagnosisCode } from "../../index";

export default function registerRoutes() {
  registerRoute({
    id: "diagnosisCodeSearch",
    route: "diagnosisCode",
    method: "get", // the OPTIONS request won't be sent when Mirage is handling the route
    generateResponse: function (config, schema, request) {
      const queryParams = request.queryParams;
      let result = (schema as any).diagnosisCodes.all();
      if (queryParams) {
        if (queryParams.query) {
          result = (schema as any).diagnosisCodes.where(
            (item: DiagnosisCode) => {
              return (
                item.code?.match(new RegExp(queryParams.query, "i")) ||
                item.description?.match(new RegExp(queryParams.query, "i"))
              );
            }
          );
        }
      }
      // Limit to first 10
      result.models = result.models.slice(0, 10);
      return result;
    },
  });
}
